// extracted by mini-css-extract-plugin
export default {"create-category":"CreateCategory_create-category__amaA2","action":"CreateCategory_action__BfoqT","btn":"CreateCategory_btn__60IH5"};